import { useStaticQuery, graphql } from 'gatsby';

export interface CollectionsQueryResult {
  mongodb_id: string;
  lesson_id: number;
  name: string;
  tags: string[];
  hidden?: boolean;
}

export const useCollections = () => {
  const { collections } = useStaticQuery(
    graphql`
      query CollectionsQuery {
        collections: allMongodbChineseCollections {
          nodes {
            lesson_id
            mongodb_id
            name
            hanzis
            tags
          }
        }
      }
    `
  );
  return collections;
};
